/* eslint-disable react-native/no-inline-styles */
/* eslint-disable curly */
/* eslint-disable react-native/no-color-literals */

export const customLogErrorWarning = () => {
  const errorLogs = [];

  const originalConsoleError = console.error;
  console.error = (...args) => {
    originalConsoleError(...args);

    const timestamp = new Date().toLocaleTimeString();
    errorLogs.unshift({
      id: Date.now().toString(),
      message: args
        .map((arg) =>
          typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg),
        )
        .join(' '),
      timestamp,
      type: 'error',
    });

    if (errorLogs.length > 100) {
      errorLogs.pop();
    }
  };

  const originalConsoleWarn = console.warn;
  console.warn = (...args) => {
    originalConsoleWarn(...args);

    const timestamp = new Date().toLocaleTimeString();
    errorLogs.unshift({
      id: Date.now().toString(),
      message: args
        .map((arg) =>
          typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg),
        )
        .join(' '),
      timestamp,
      type: 'warning',
    });

    // Limit log size
    if (errorLogs.length > 100) {
      errorLogs.pop();
    }
  };

  return errorLogs;
};
